import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { K2StaticDatumsEdit } from "./edit";
import { K2StaticDataNew } from "./new";
import { K2StaticDatumsTable } from "./table";
export default function K2StaticDatums() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Actifs");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<K2StaticDatumsEdit />} />
      <Route index element={<K2StaticDatumsTable />} />
      <Route path="/new" element={<K2StaticDataNew />} />
    </Routes>
  );
}
